"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class BaseConnection extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '871718518003014972',
        defaultValue: '871718518003014972',
        description: `The EAN code of this connection. Has no influence on the rates, but can be used as a unqiue identifier of a connection.`,
    }),
    tslib_1.__metadata("design:type", String)
], BaseConnection.prototype, "connectEan", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '871718518003014972',
        defaultValue: '871718518003014972',
        description: `The net area EAN, can be retrieved from EDSN also for non existing customers.
This determines in which "region" you live, numbered from 01 up to 10.
For each region there is a different supply rate.
For example with the same installation and segment, but different net area, could result in a difference of 0.01 euro in unit price.`,
    }),
    tslib_1.__metadata("design:type", String)
], BaseConnection.prototype, "netAreaEAN", void 0);
exports.default = BaseConnection;
